import "./Login.css";
import Header from "../../components/Layouts/Header";
import Layout from "../../components/Layouts/Layout";
import Footer from "../../components/Layouts/Footer";
import Form from "react-bootstrap/Form";
import { useState, useEffect } from "react";
import Instance from "../../Utils/Axios";
import { Link, useNavigate } from "react-router-dom";
import { showToast } from "../../Utils/index";
import useFormValidation from "../../Hooks/useformValidation";
import { signInSchema } from "../../Utils/validationSchema";
import { FormGroup } from "react-bootstrap";
import { toast } from "react-toastify";
import PremiumLoader from "../../components/Loader/PremiumLoader";

export default function Login() {
  const [visible, setVisible] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [loginStatus, setLoginStatus] = useState("idle");
  const [initialLoading, setInitialLoading] = useState(true);

  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useFormValidation(signInSchema);

  const handleViewPassword = () => setVisible(!visible);

  const loginUser = async (data) => {
    setLoading(true);
    setError("");
    try {
      const response = await Instance.post("/user/login", {
        email: data.username,
        password: data.password,
        skipCSRF: 1,
        skipLoginOTP: 1,
      });

      localStorage.setItem("tokenId", response.data.tokenId);
      showToast("Login successful!", "success", "success");
      setLoading(false);
      setLoginStatus("success");
      setTimeout(() => {

        navigate("/customer/dashboard");
      }, 2000);

    } catch (error) {
      setLoading(false);

      const resMessage =
        error?.response?.data?.message;

      showToast(resMessage, "error");
      setError(resMessage);
      setLoginStatus("error");
    }
  };

  useEffect(() => {
    const token = localStorage.getItem("tokenId");
    if (token) {
      showToast("You are already logged in!", "success");
      setTimeout(() => {
        navigate("/customer/dashboard", { replace: true });
      }, 2000);
    } else {
      setInitialLoading(false);
    }
  }, [navigate]);

  useEffect(() => {
    return () => {
      toast.dismiss();
    };
  }, []);

  if (initialLoading) {
    return <PremiumLoader text="Initializing Login..." />;
  }

  return (
    <div className="full_screen">
      <Header />
      <div className="content">
        <Layout>
          <div className="col-11 col-md-8 col-lg-6 signin_container mx-auto">
            <h1>Sign In</h1>
            <Form onSubmit={handleSubmit(loginUser)}>
              <div className="signin_wrapper">
                <FormGroup>
                  <Form.Control
                    type="email"
                    placeholder="Enter your registered email address"
                    {...register("username")}
                    isInvalid={!!errors.username}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.username?.message}
                  </Form.Control.Feedback>
                </FormGroup>

                <FormGroup className="password-wrapper">
                  <div className="input-icon-wrapper">
                    <Form.Control
                      type={visible ? "text" : "password"}
                      placeholder="Enter your password"
                      {...register("password")}
                      isInvalid={!!errors.password}
                    />
                    <i
                      className={`bi ${visible ? "bi-eye" : "bi-eye-slash"} toggle-password-icon`}
                      onClick={handleViewPassword}
                      style={{ fontSize: "20px" }}
                    ></i>
                  </div>
                  <Form.Control.Feedback
                    type="invalid"
                    className="d-block feedback-message"
                  >
                    {errors.password?.message}
                  </Form.Control.Feedback>
                </FormGroup>

                <Link to="/forgot" className="mb-2 forgot text-nowrap d-block text-center">
                  Forgot Password?
                </Link>

                <button
                  type="submit"
                  className={`signin_btn ${loginStatus === "success" ? "success" : ""
                    }`}
                  disabled={loading || loginStatus === "success"}
                >
                  {loginStatus === "success"
                    ? "Login Successful"
                    : loading
                      ? "Signing in..."
                      : "Login"}
                </button>

                {error && (
                  <div className="text-danger" style={{ marginTop: "-10px" }}>
                    {error.toLowerCase().includes("not registered") && (
                      <>
                        {" "}
                        <Link
                          to="/signup"
                          className="text-decoration-underline"
                        >
                          Create an account
                        </Link>
                      </>
                    )}
                  </div>
                )}

                <p className="mb-0 text-center or">OR</p>

                <div className="d-flex justify-content-between">
                  <div className="d-flex gap-2 auth_btn">
                    <img
                      className="logo"
                      src="/build/Google_Logo.svg"
                      alt="Google"
                      width={24}
                      height={24}
                    />
                    <p>Sign in with Google</p>
                  </div>

                  <div className="d-flex gap-2 auth_btn auth_btn_two">
                    <img
                      className="logo"
                      src="/build/Google_Logo.svg"
                      alt="Apple"
                      width={24}
                      height={24}
                    />
                    <p>Sign in with Apple</p>
                  </div>
                </div>

                <div className="mt-4 text-center">
                  <p className="mb-0" style={{ fontSize: "14px", color: "#666" }}>
                    Don't have an account?{" "}
                    <Link to="/signup" style={{ color: "#595fde", fontWeight: "600" }}>
                      Create New Account
                    </Link>
                  </p>
                </div>

              </div>
            </Form>
          </div>
        </Layout>
      </div>
    </div>
  );
}
